import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./form-item-student-loans-quote.component.scss";
var FormItemStudentLoansQuote = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemStudentLoansQuote, _super);
    function FormItemStudentLoansQuote(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemStudentLoansQuote.prototype.init = function () {
        if (document.getElementById("form-container-modal-student-loans-quote")) {
            this.studentModalElement = document
                .getElementById("form-container-modal-student-loans-quote")
                .getElementsByClassName("modal__dialog")[0];
        }
        if (document.getElementById("apply-now-modal-formdf7aefec43ec7710VgnVCM2000008811960aRCRD")) {
            this.studentBottomModalElement = document
                .getElementById("apply-now-modal-formdf7aefec43ec7710VgnVCM2000008811960aRCRD")
                .getElementsByClassName("modal__dialog")[0];
        }
        this.formFields = this.element.querySelector(".form__fields--container");
        this.form = this.element.querySelector("form");
        this.buttonSubmit = this.element.querySelector(".js-student-loans-quote-submit");
        this.callMeBackSubmit = this.element.querySelectorAll(".call-me-back-student");
        if (this.studentBottomModalElement) {
            this.onClose = this.studentBottomModalElement.querySelectorAll(".js-apply-now-modal-close");
        }
        var modalStudentLoansQuote = document.querySelectorAll("#form-container-modal-student-loans-quote");
        if (modalStudentLoansQuote != null && modalStudentLoansQuote[0] != null) {
            this.onCloseBottomModal = modalStudentLoansQuote[0].querySelectorAll(".js-apply-now-modal-close");
        }
        this.visitBranchSubmit = this.element.querySelectorAll(".visit-branch-student");
        this.callMeBackSuretySubmit =
            this.element.querySelectorAll(".call-me-back-surety");
        this.visitBranchSuretySubmit =
            this.element.querySelectorAll(".visit-branch-surety");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.buttonNextStep1 = this.element.querySelector(".js_stu-loans_next-step-button-1");
        this.showConsents = this.element.querySelector(".consents-show");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form__loader--container");
            this.displayFields = this.form.querySelector(".form__fields--container");
            this.displaySuccess = this.form.querySelector(".form__success--container");
            this.displayError = this.form.querySelector(".form__error--container");
            this.displayCallMeBack = this.form.querySelector(".call-me-back--container");
            this.displayVisitBranch = this.form.querySelector(".visitbranch--container");
            this.displayVisitBranchSurety = this.form.querySelector(".visitbranch-surety--container");
            this.displayOfferPending = this.form.querySelector(".offer-pending--container");
            this.displayCallMeBackSurety = this.form.querySelector(".call-me-back-surety--container");
            this.displayLoanExists = this.form.querySelector(".form__declined--container__loan-exists");
            this.displayStudentReferral = this.form.querySelector(".form__declined--container__student-referral");
            this.displaySuretyReferral = this.form.querySelector(".form__declined--container__surety-referral");
            this.displayStudentDeclined = this.form.querySelector(".form__declined--container__student");
            this.displaySuretyDeclined = this.form.querySelector(".form__declined--container__surety");
            this.displayStudentSuccess = this.form.querySelector(".form__success--container-pc__student");
            this.displaySuretySuccess = this.form.querySelector(".form__success--container-pc__surety");
        }
        this.paymentDetailsSelection = Array.from(this.element.querySelectorAll("input[name=\"payment-details\""));
        this.paymentDetails = "";
        // Student Details
        this.studentDetailsInfoDiv =
            this.element.querySelector(".student-details");
        this.studentGross = this.element.querySelector("input[name=\"student-gross\"");
        this.studentExpenses = this.element.querySelector("input[name=\"student-expenses\"");
        this.studentContactNumber = this.element.querySelector("input[name=student-contact-number]");
        // Student consents
        // this.studentConsentsHeading = this.element.querySelector(`.student-consents-heading`);
        // this.studentDebtConsent = this.element.querySelector(`input[name=student-debt-consent]`);
        // this.studentConsent = this.element.querySelector(`input[name=student-consent]`);
        // this.studentPersonalisedConsent = this.element.querySelector(`input[name=student-personlised-consent]`);
        // Student marketing consents
        // this.studentMarketingConsentsHeading = this.element.querySelector(`.student-marketing-consents-heading`);
        // this.studentMarketPersonalisedConsent = this.element.querySelector(`input[name=student-market-personlised-consent]`);
        // this.studentMarketShareConsent = this.element.querySelector(`input[name=student-market-share-consent]`);
        // this.studentMarketPrivacyConsent = this.element.querySelector(`input[name=student-market-privacy-consent]`);
        // Surety Details
        // this.suretyHeading = this.element.querySelector(`.surety-heading`);
        this.suretyFirstName = this.element.querySelector("input[name=\"surety-first-name\"");
        this.suretySurname = this.element.querySelector("input[name=\"surety-surname\"");
        this.suretyIdNumber = this.element.querySelector("input[name=\"surety-sa-id\"");
        this.suretyContactNumber = this.element.querySelector("input[name=\"surety-contact-number\"");
        this.suretyEmailAddress = this.element.querySelector("input[name=\"surety-emailAddress\"");
        this.suretyGross = this.element.querySelector("input[name=\"surety-gross\"");
        this.suretyExpenses = this.element.querySelector("input[name=\"surety-expenses\"");
        // Surety consents
        // this.suretyConsentsHeading = this.element.querySelector(`.surety-consents-heading`);
        // this.suretyDebtConsent = this.element.querySelector(`input[name=surety-debt-consent]`);
        // this.suretyConsent = this.element.querySelector(`input[name=surety-consent]`);
        this.suretyAuthConsent = this.element.querySelector("input[name=surety-auth-consent]");
        // this.suretyPersonalisedConsent = this.element.querySelector(`input[name=surety-personlised-consent]`);
        // Surety marketing consents
        // this.suretyMarketingConsentsHeading = this.element.querySelector(`.surety-marketing-consents-heading`);
        // this.suretyMarketPersonalisedConsent = this.element.querySelector(`input[name=surety-market-personlised-consent]`);
        // this.suretyMarketShareConsent = this.element.querySelector(`input[name=surety-market-share-consent]`);
        // this.suretyMarketPrivacyConsent = this.element.querySelector(`input[name=surety-market-privacy-consent]`);
        // Correct Info Container
        this.studentSuretyConsentInfoDiv = this.element.querySelector(".student-surety-consent-info");
        // Analytics
        this.analyticsFormData();
    };
    FormItemStudentLoansQuote.prototype.bindEvents = function () {
        var _this = this;
        if (this.callMeBackSubmit) {
            Array.from(this.callMeBackSubmit).forEach(function (item) {
                item.addEventListener("click", function (event) {
                    var _button = event.target;
                    var _form = _button.closest("form");
                    _this.callMeBack(_form, "student");
                });
            });
        }
        if (this.onClose) {
            Array.from(this.onClose).forEach(function (item) {
                item.addEventListener("click", function (event) {
                    _this.closeForm();
                });
            });
        }
        if (this.onCloseBottomModal) {
            Array.from(this.onCloseBottomModal).forEach(function (item) {
                item.addEventListener("click", function (event) {
                    _this.closeForm();
                });
            });
        }
        if (this.visitBranchSubmit) {
            Array.from(this.visitBranchSubmit).forEach(function (item) {
                item.addEventListener("click", function (event) {
                    var _button = event.target;
                    var _form = _button.closest("form");
                    _this.visitBranch(_form, "student");
                });
            });
        }
        if (this.callMeBackSuretySubmit) {
            Array.from(this.callMeBackSuretySubmit).forEach(function (item) {
                item.addEventListener("click", function (event) {
                    var _button = event.target;
                    var _form = _button.closest("form");
                    _this.callMeBack(_form, "surety");
                });
            });
        }
        if (this.visitBranchSuretySubmit) {
            Array.from(this.visitBranchSuretySubmit).forEach(function (item) {
                item.addEventListener("click", function (event) {
                    var _button = event.target;
                    var _form = _button.closest("form");
                    _this.visitBranch(_form, "surety");
                });
            });
        }
        if (this.showConsents) {
            this.showConsents.classList.add("form__group--hidden");
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input:not([data-name]), select, textarea");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0 && !_this.studentLoansQuoteValidations(event)) {
                    // loader + hide form
                    _this.showDisplayView("loader");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm(_form);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm(_form);
                        }
                    }
                    else {
                        _this.submitForm(_form);
                    }
                }
            });
        }
        if (this.buttonNextStep1) {
            this.buttonNextStep1.addEventListener("click", function (event) {
                if (_this.studentLoansQuoteValidations(event)) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.paymentDetailsSelection.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.paymentDetails = evt.value;
                if (_this.showConsents) {
                    _this.showConsents.classList.remove("form__group--hidden");
                }
                _this.updatePaymentDetails(_this.paymentDetails);
                _this.studentSuretyConsentCheck();
            });
        });
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            var success = _this.element.querySelector(".form__success--container");
            if (success) {
                success.classList.remove("active");
            }
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
            valid.map(function (pElem) {
                pElem.classList.remove("form__group--error");
                var errorMessage = pElem.querySelector(".form__group--error_message");
                if (errorMessage) {
                    errorMessage.remove();
                }
            });
            _this.resetForm();
        }, false);
    };
    FormItemStudentLoansQuote.prototype.getCardinalPageID = function (name, url) {
        if (url === void 0) { url = window.location.href; }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) {
            return "";
        }
        else if (!results[2]) {
            return "";
        }
        else {
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    };
    FormItemStudentLoansQuote.prototype.analyticsFormData = function () {
        if (dataLayer) {
            dataLayer.application.applicationName = "application: student loans ";
            dataLayer.application.applicationProduct = "Student Loan";
            dataLayer.application.applicationMethod = "online";
            dataLayer.application.applicationStart = true;
            dataLayer.application.applicationComplete = false;
        }
    };
    FormItemStudentLoansQuote.prototype.getSha256 = function (studentContactNumber) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encodeStr, hashStr, hashArray, hashHex;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encodeStr = new TextEncoder().encode(studentContactNumber);
                        return [4 /*yield*/, window.crypto.subtle.digest("SHA-1", encodeStr)];
                    case 1:
                        hashStr = _a.sent();
                        hashArray = Array.from(new Uint8Array(hashStr));
                        hashHex = hashArray
                            .map(function (bytes) { return ("00" + bytes.toString(16)).slice(-2); })
                            .join("");
                        return [2 /*return*/, hashHex];
                }
            });
        });
    };
    FormItemStudentLoansQuote.prototype.updatePaymentDetails = function (paymentDetails) {
        if (paymentDetails === "STUDENT") {
            this.hideSuretyDetails();
            this.showStudentDetails();
            this.hideSuretyConsents();
            this.showStudentConsents();
        }
        if (paymentDetails === "SURETY") {
            this.hideStudentDetails();
            this.showSuretyDetails();
            this.hideStudentConsents();
            this.showSuretyConsents();
        }
    };
    FormItemStudentLoansQuote.prototype.showStudentDetails = function () {
        this.studentDetailsInfoDiv.classList.remove("form__group--hidden");
        var studentGrossGroup = this.studentGross.closest(".form__group");
        studentGrossGroup.classList.remove("form__group--hidden");
        var studentExpensesGroup = this.studentExpenses.closest(".form__group");
        studentExpensesGroup.classList.remove("form__group--hidden");
        // const studentConsentGroup = this.studentConsent.closest(`.form__group`);
        // studentConsentGroup.classList.remove(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.hideStudentDetails = function () {
        this.studentDetailsInfoDiv.classList.add("form__group--hidden");
        var studentGrossGroup = this.studentGross.closest(".form__group");
        studentGrossGroup.classList.add("form__group--hidden");
        var studentExpensesGroup = this.studentExpenses.closest(".form__group");
        studentExpensesGroup.classList.add("form__group--hidden");
        // const studentConsentGroup = this.studentConsent.closest(`.form__group`);
        // studentConsentGroup.classList.add(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.showSuretyDetails = function () {
        // this.suretyHeading.classList.remove(`form__group--hidden`);
        var suretyFirstNameGroup = this.suretyFirstName.closest(".form__group");
        suretyFirstNameGroup.classList.remove("form__group--hidden");
        var suretySurnameGroup = this.suretySurname.closest(".form__group");
        suretySurnameGroup.classList.remove("form__group--hidden");
        var suretyIdNumberGroup = this.suretyIdNumber.closest(".form__group");
        suretyIdNumberGroup.classList.remove("form__group--hidden");
        var suretyContactNumberGroup = this.suretyContactNumber.closest(".form__group");
        suretyContactNumberGroup.classList.remove("form__group--hidden");
        var suretyEmailAddressGroup = this.suretyEmailAddress.closest(".form__group");
        suretyEmailAddressGroup.classList.remove("form__group--hidden");
        var suretyGrossGroup = this.suretyGross.closest(".form__group");
        suretyGrossGroup.classList.remove("form__group--hidden");
        var suretyExpensesGroup = this.suretyExpenses.closest(".form__group");
        suretyExpensesGroup.classList.remove("form__group--hidden");
        // const suretyConsentGroup = this.suretyConsent.closest(`.form__group`);
        // suretyConsentGroup.classList.remove(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.hideSuretyDetails = function () {
        // this.suretyHeading.classList.add(`form__group--hidden`);
        var suretyFirstNameGroup = this.suretyFirstName.closest(".form__group");
        suretyFirstNameGroup.classList.add("form__group--hidden");
        var suretySurnameGroup = this.suretySurname.closest(".form__group");
        suretySurnameGroup.classList.add("form__group--hidden");
        var suretyIdNumberGroup = this.suretyIdNumber.closest(".form__group");
        suretyIdNumberGroup.classList.add("form__group--hidden");
        var suretyContactNumberGroup = this.suretyContactNumber.closest(".form__group");
        suretyContactNumberGroup.classList.add("form__group--hidden");
        var suretyEmailAddressGroup = this.suretyEmailAddress.closest(".form__group");
        suretyEmailAddressGroup.classList.add("form__group--hidden");
        var suretyGrossGroup = this.suretyGross.closest(".form__group");
        suretyGrossGroup.classList.add("form__group--hidden");
        var suretyExpensesGroup = this.suretyExpenses.closest(".form__group");
        suretyExpensesGroup.classList.add("form__group--hidden");
        // const suretyConsentGroup = this.suretyConsent.closest(`.form__group`);
        // suretyConsentGroup.classList.add(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.showStudentConsents = function () {
        // this.studentConsentsHeading.classList.remove(`form__group--hidden`);
        // const studentDebtConsentGroup = this.studentDebtConsent.closest(`.form__group`);
        // studentDebtConsentGroup.classList.remove(`form__group--hidden`);
        // const studentConsentGroup = this.studentConsent.closest(`.form__group`);
        // studentConsentGroup.classList.remove(`form__group--hidden`);
        // const studentPersonalisedConsentGroup = this.studentPersonalisedConsent.closest(`.form__group`);
        // studentPersonalisedConsentGroup.classList.remove(`form__group--hidden`);
        // this.studentMarketingConsentsHeading.classList.remove(`form__group--hidden`);
        // const studentMarketPersonalisedConsentGroup = this.studentMarketPersonalisedConsent.closest(`.form__group`);
        // studentMarketPersonalisedConsentGroup.classList.remove(`form__group--hidden`);
        // const studentMarketShareConsentGroup = this.studentMarketShareConsent.closest(`.form__group`);
        // studentMarketShareConsentGroup.classList.remove(`form__group--hidden`);
        // const studentMarketPrivacyConsentGroup = this.studentMarketPrivacyConsent.closest(`.form__group`);
        // studentMarketPrivacyConsentGroup.classList.remove(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.hideStudentConsents = function () {
        // this.studentConsentsHeading.classList.add(`form__group--hidden`);
        // const studentDebtConsentGroup = this.studentDebtConsent.closest(`.form__group`);
        // studentDebtConsentGroup.classList.add(`form__group--hidden`);
        // const studentConsentGroup = this.studentConsent.closest(`.form__group`);
        // studentConsentGroup.classList.add(`form__group--hidden`);
        // const studentPersonalisedConsentGroup = this.studentPersonalisedConsent.closest(`.form__group`);
        // studentPersonalisedConsentGroup.classList.add(`form__group--hidden`);
        // this.studentMarketingConsentsHeading.classList.add(`form__group--hidden`);
        // const studentMarketPersonalisedConsentGroup = this.studentMarketPersonalisedConsent.closest(`.form__group`);
        // studentMarketPersonalisedConsentGroup.classList.add(`form__group--hidden`);
        // const studentMarketShareConsentGroup = this.studentMarketShareConsent.closest(`.form__group`);
        // studentMarketShareConsentGroup.classList.add(`form__group--hidden`);
        // const studentMarketPrivacyConsentGroup = this.studentMarketPrivacyConsent.closest(`.form__group`);
        // studentMarketPrivacyConsentGroup.classList.add(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.showSuretyConsents = function () {
        // this.suretyConsentsHeading.classList.remove(`form__group--hidden`);
        // const suretyDebtConsentGroup = this.suretyDebtConsent.closest(`.form__group`);
        // suretyDebtConsentGroup.classList.remove(`form__group--hidden`);
        // const suretyConsentGroup = this.suretyConsent.closest(`.form__group`);
        // suretyConsentGroup.classList.remove(`form__group--hidden`);
        var suretyAuthConsentGroup = this.suretyAuthConsent.closest(".form__group");
        suretyAuthConsentGroup.classList.remove("form__group--hidden");
        // const suretyPersonalisedConsentGroup = this.suretyPersonalisedConsent.closest(`.form__group`);
        // suretyPersonalisedConsentGroup.classList.remove(`form__group--hidden`);
        // this.suretyMarketingConsentsHeading.classList.remove(`form__group--hidden`);
        // const suretyMarketPersonalisedConsentGroup = this.suretyMarketPersonalisedConsent.closest(`.form__group`);
        // suretyMarketPersonalisedConsentGroup.classList.remove(`form__group--hidden`);
        // const suretyMarketShareConsentGroup = this.suretyMarketShareConsent.closest(`.form__group`);
        // suretyMarketShareConsentGroup.classList.remove(`form__group--hidden`);
        // const suretyMarketPrivacyConsentGroup = this.suretyMarketPrivacyConsent.closest(`.form__group`);
        // suretyMarketPrivacyConsentGroup.classList.remove(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.hideSuretyConsents = function () {
        // this.suretyConsentsHeading.classList.add(`form__group--hidden`);
        // const suretyDebtConsentGroup = this.suretyDebtConsent.closest(`.form__group`);
        // suretyDebtConsentGroup.classList.add(`form__group--hidden`);
        // const suretyConsentGroup = this.suretyConsent.closest(`.form__group`);
        // suretyConsentGroup.classList.add(`form__group--hidden`);
        var suretyAuthConsentGroup = this.suretyAuthConsent.closest(".form__group");
        suretyAuthConsentGroup.classList.add("form__group--hidden");
        // const suretyPersonalisedConsentGroup = this.suretyPersonalisedConsent.closest(`.form__group`);
        // suretyPersonalisedConsentGroup.classList.add(`form__group--hidden`);
        // this.suretyMarketingConsentsHeading.classList.add(`form__group--hidden`);
        // const suretyMarketPersonalisedConsentGroup = this.suretyMarketPersonalisedConsent.closest(`.form__group`);
        // suretyMarketPersonalisedConsentGroup.classList.add(`form__group--hidden`);
        // const suretyMarketShareConsentGroup = this.suretyMarketShareConsent.closest(`.form__group`);
        // suretyMarketShareConsentGroup.classList.add(`form__group--hidden`);
        // const suretyMarketPrivacyConsentGroup = this.suretyMarketPrivacyConsent.closest(`.form__group`);
        // suretyMarketPrivacyConsentGroup.classList.add(`form__group--hidden`);
    };
    FormItemStudentLoansQuote.prototype.studentSuretyConsentCheck = function () {
        if (this.paymentDetails !== "") {
            this.studentSuretyConsentInfoDiv.classList.remove("form__group--hidden");
        }
        else {
            this.studentSuretyConsentInfoDiv.classList.add("form__group--hidden");
        }
    };
    FormItemStudentLoansQuote.prototype.closeForm = function () {
        this.removeHeader("remove");
    };
    FormItemStudentLoansQuote.prototype.callMeBack = function (form, id) {
        var _this = this;
        var _studentSaId = form.querySelector("input[name=student-sa-id]");
        var _studentContactNumber = form.querySelector("input[name=student-contact-number]");
        var responseData = this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.affordabilityDetails;
        var opportuinityid = this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.preApplicationQuoteId;
        var gross = form.querySelector("input[name=student-gross]").value;
        var expenses = form.querySelector("input[name=student-expenses]").value;
        var currentdate = new Date().toISOString().split("T")[0];
        if (id !== "student") {
            gross = form.querySelector("input[name=surety-gross]").value;
            expenses = form.querySelector("input[name=surety-expenses]").value;
        }
        var requestData = {
            phoneNumber: _studentContactNumber
                ? _studentContactNumber.value
                : "",
            idNumber: _studentSaId ? _studentSaId.value : "",
            contactTime: "0",
            contactDate: currentdate,
            opportunityId: opportuinityid,
            productId: "ZSLA",
            maximumApprovedAmount: responseData.approvedAmount,
            grossIncome: gross,
            grossExpenses: expenses,
            itemId: "10",
            bpId: "",
        };
        var url = this.baseUrl + "/leadsutils/studentloansplmgmt";
        var _config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        this.removeHeader("add");
        this.formsService
            .postForm(url, requestData, _config)
            .then(function (pResponse) {
            if (_this.studentModalElement) {
                _this.studentModalElement.classList.add("modal__dialog--small");
                _this.studentModalElement.classList.remove("modal__dialog--x-large");
            }
            if (_this.studentBottomModalElement) {
                _this.studentBottomModalElement.classList.add("modal__dialog--small");
                _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
            }
            if (pResponse.data.success) {
                _this.analyticsService.dtmFormComplete("complete", "200", true);
                if (id === "student") {
                    _this.showDisplayView("callmeback");
                }
                else {
                    _this.showDisplayView("callmebacksurety");
                }
            }
            else {
                if (_this.studentModalElement) {
                    _this.studentModalElement.classList.add("modal__dialog--small");
                    _this.studentModalElement.classList.remove("modal__dialog--x-large");
                }
                if (_this.studentBottomModalElement) {
                    _this.studentBottomModalElement.classList.add("modal__dialog--small");
                    _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
                }
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                // show screen
                _this.showDisplayView("error");
            }
        })
            .catch(function (response) {
            if (_this.studentModalElement) {
                _this.studentModalElement.classList.add("modal__dialog--small");
                _this.studentModalElement.classList.remove("modal__dialog--x-large");
            }
            if (_this.studentBottomModalElement) {
                _this.studentBottomModalElement.classList.add("modal__dialog--small");
                _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
            }
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemStudentLoansQuote.prototype.visitBranch = function (form, id) {
        var _this = this;
        var _studentSaId = form.querySelector("input[name=student-sa-id]");
        var _studentContactNumber = form.querySelector("input[name=student-contact-number]");
        var responseData = this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.affordabilityDetails;
        var opportuinityid = this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.preApplicationQuoteId;
        var gross = form.querySelector("input[name=student-gross]").value;
        var expenses = form.querySelector("input[name=student-expenses]").value;
        var currentdate = new Date().toISOString().split("T")[0];
        if (id !== "student") {
            gross = form.querySelector("input[name=surety-gross]").value;
            expenses = form.querySelector("input[name=surety-expenses]").value;
        }
        var requestData = {
            phoneNumber: _studentContactNumber
                ? _studentContactNumber.value
                : "",
            idNumber: _studentSaId ? _studentSaId.value : "",
            contactTime: "VISITBRANCH",
            contactDate: currentdate,
            opportunityId: opportuinityid,
            productId: "ZSLA",
            maximumApprovedAmount: responseData.approvedAmount,
            grossIncome: gross,
            grossExpenses: expenses,
            itemId: "10",
            bpId: "",
        };
        var url = this.baseUrl + "/leadsutils/studentloansplmgmt";
        var _config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        this.formsService
            .postForm(url, requestData, _config)
            .then(function (pResponse) {
            _this.removeHeader("add");
            if (_this.studentModalElement) {
                _this.studentModalElement.classList.add("modal__dialog--small");
                _this.studentModalElement.classList.remove("modal__dialog--x-large");
            }
            if (_this.studentBottomModalElement) {
                _this.studentBottomModalElement.classList.add("modal__dialog--small");
                _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
            }
            if (pResponse.data.success) {
                _this.analyticsService.dtmFormComplete("complete", "200", true);
                if (id === "student") {
                    _this.showDisplayView("visitbranch");
                }
                else {
                    _this.showDisplayView("visitbranchsurety");
                }
            }
            else {
                if (_this.studentModalElement) {
                    _this.studentModalElement.classList.add("modal__dialog--small");
                    _this.studentModalElement.classList.remove("modal__dialog--x-large");
                }
                if (_this.studentBottomModalElement) {
                    _this.studentBottomModalElement.classList.add("modal__dialog--small");
                    _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
                }
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                // show screen
                _this.showDisplayView("error");
            }
        })
            .catch(function (response) {
            if (_this.studentModalElement) {
                _this.studentModalElement.classList.add("modal__dialog--small");
                _this.studentModalElement.classList.remove("modal__dialog--x-large");
            }
            if (_this.studentBottomModalElement) {
                _this.studentBottomModalElement.classList.add("modal__dialog--small");
                _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
            }
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemStudentLoansQuote.prototype.submitForm = function (form) {
        var _this = this;
        // cardinal ID
        var _cardinalId = this.getCardinalPageID("cid");
        // student
        var _studentFirstName = form.querySelector("input[name=student-first-name]");
        var _studentSurname = form.querySelector("input[name=student-surname]");
        var _studentSaId = form.querySelector("input[name=student-sa-id]");
        var _studentContactNumber = form.querySelector("input[name=student-contact-number]");
        var _studentEmail = form.querySelector("input[name=emailAddress]");
        var _province = form.querySelector("select[name=province]");
        var _qualificationType = form.querySelector("select[name=qualification-type]");
        var _yearofStudy = form.querySelector("select[name=current-yearofstudy]");
        var _courseDuration = form.querySelector("select[name=course-duration]");
        var _requestedLoanAmount = form.querySelector("input[name=requested-loan-amount]");
        var _studentGross = form.querySelector("input[name=student-gross]");
        var _studentExpenses = form.querySelector("input[name=student-expenses]");
        // student consents
        var _studentDebtConsent = form.querySelector("input[name=student-debt-consent]");
        var _studentConsent = form.querySelector("input[name=student-consent]");
        var _studentPersonalisedConsent = form.querySelector("input[name=student-personlised-consent]");
        // student marketing consents
        var _studentMarketPersonalisedConsent = form.querySelector("input[name=student-market-personlised-consent]");
        var _studentMarketShareConsent = form.querySelector("input[name=student-market-share-consent]");
        var _studentMarketPrivacyConsent = form.querySelector("input[name=student-market-privacy-consent]");
        // surety
        var _suretyFirstName = form.querySelector("input[name=surety-first-name]");
        var _suretySurname = form.querySelector("input[name=surety-surname]");
        var _suretySaId = form.querySelector("input[name=surety-sa-id]");
        var _suretyContactNumber = form.querySelector("input[name=surety-contact-number]");
        var _suretyEmail = form.querySelector("input[name=surety-emailAddress]");
        var _suretyGross = form.querySelector("input[name=surety-gross]");
        var _suretyExpenses = form.querySelector("input[name=surety-expenses]");
        // surety consents
        var _suretyDebtConsent = form.querySelector("input[name=surety-debt-consent]");
        var _suretyConsent = form.querySelector("input[name=surety-consent]");
        var _suretyAuthConsent = form.querySelector("input[name=surety-auth-consent]");
        var _dataPrivacy = form.querySelector("input[name=popia-consent]");
        var _suretyPersonalisedConsent = form.querySelector("input[name=surety-personlised-consent]");
        // surety marketing consents
        var _suretyMarketPersonalisedConsent = form.querySelector("input[name=surety-market-personlised-consent]");
        var _suretyMarketShareConsent = form.querySelector("input[name=surety-market-share-consent]");
        var _suretyMarketPrivacyConsent = form.querySelector("input[name=surety-market-privacy-consent]");
        var _postData = {};
        if (this.paymentDetails === "STUDENT") {
            _postData = {
                studentDetails: {
                    idNumber: _studentSaId ? _studentSaId.value : "",
                    idType: "01",
                    emailAddress: _studentEmail ? _studentEmail.value : "",
                    firstName: _studentFirstName ? _studentFirstName.value : "",
                    lastName: _studentSurname ? _studentSurname.value : "",
                    identificationType: "01",
                    cellPhoneNumber: _studentContactNumber
                        ? _studentContactNumber.value
                        : "",
                },
                hasSurety: false,
                quoteDetails: {
                    expenditure: {
                        amount: _studentExpenses
                            ? parseInt(_studentExpenses.value)
                            : 0,
                        currency: "ZAR",
                    },
                    grossIncome: {
                        amount: _studentGross
                            ? parseInt(_studentGross.value)
                            : 0,
                        currency: "ZAR",
                    },
                    loanAmount: {
                        amount: _requestedLoanAmount
                            ? parseInt(_requestedLoanAmount.value)
                            : 0,
                        currency: "ZAR",
                    },
                    qualificationType: _qualificationType
                        ? _qualificationType.value
                        : "",
                    courseDuration: (_courseDuration ? _courseDuration.value : ""),
                    currentYearOfStudy: (_yearofStudy ? _yearofStudy.value : ""),
                    province: _province ? _province.value : "",
                },
                privacyStatementConsent: _dataPrivacy.checked,
                insolventConsent: _studentDebtConsent.checked,
                cardinalId: _cardinalId,
                recaptchaToken: this.gRecaptchaToken
            };
        }
        else if (this.paymentDetails === "SURETY") {
            _postData = {
                studentDetails: {
                    idNumber: _studentSaId ? _studentSaId.value : "",
                    idType: "01",
                    emailAddress: _studentEmail ? _studentEmail.value : "",
                    firstName: _studentFirstName ? _studentFirstName.value : "",
                    lastName: _studentSurname ? _studentSurname.value : "",
                    identificationType: "01",
                    cellPhoneNumber: _studentContactNumber
                        ? _studentContactNumber.value
                        : "",
                },
                hasSurety: true,
                suretyDetails: {
                    idNumber: _suretySaId ? _suretySaId.value : "",
                    idType: "01",
                    emailAddress: _suretyEmail ? _suretyEmail.value : "",
                    firstName: _suretyFirstName ? _suretyFirstName.value : "",
                    lastName: _suretySurname ? _suretySurname.value : "",
                    identificationType: "01",
                    cellPhoneNumber: _suretyContactNumber
                        ? _suretyContactNumber.value
                        : "",
                },
                quoteDetails: {
                    expenditure: {
                        amount: _suretyExpenses
                            ? parseInt(_suretyExpenses.value)
                            : 0,
                        currency: "ZAR",
                    },
                    grossIncome: {
                        amount: _suretyGross ? parseInt(_suretyGross.value) : 0,
                        currency: "ZAR",
                    },
                    loanAmount: {
                        amount: _requestedLoanAmount
                            ? parseInt(_requestedLoanAmount.value)
                            : 0,
                        currency: "ZAR",
                    },
                    qualificationType: _qualificationType
                        ? _qualificationType.value
                        : "",
                    courseDuration: (_courseDuration ? _courseDuration.value : ""),
                    currentYearOfStudy: (_yearofStudy ? _yearofStudy.value : ""),
                    province: _province ? _province.value : "",
                },
                suretyConsent: _suretyAuthConsent.checked,
                privacyStatementConsent: _dataPrivacy.checked,
                insolventConsent: _studentDebtConsent.checked,
                cardinalId: _cardinalId,
                recaptchaToken: this.gRecaptchaToken
            };
        }
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/leadsutils/createstudentloansquote";
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        if (this.showConsents) {
            this.showConsents.classList.add("form__group--hidden");
        }
        // service
        this.formsService
            .postForm(url, _postData, config)
            .then(function (pResponse) {
            if (_this.studentModalElement) {
                _this.studentModalElement.classList.add("modal__dialog--small");
                _this.studentModalElement.classList.remove("modal__dialog--x-large");
            }
            if (_this.studentBottomModalElement) {
                _this.studentBottomModalElement.classList.add("modal__dialog--small");
                _this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
            }
            if (!pResponse.data) {
                // analytics
                _this.analyticsService.dtmProductViewDetails('loans', 'insurance', 'student loans', 0, 0, 0, 'error');
                _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
                // show screen
                _this.showDisplayView("error");
            }
            else if (pResponse.data.captchaResponse != null && pResponse.data.captchaResponse == false) {
                _this.analyticsService.dtmProductViewDetails('loans', 'insurance', 'student loans', 0, 0, 0, 'error');
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                // show screen
                _this.showDisplayView("error");
            }
            else if (pResponse.data["error"] || pResponse.data.responseCode == 50000) {
                // analytics
                _this.analyticsService.dtmProductViewDetails('loans', 'insurance', 'student loans', 0, 0, 0, 'error');
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                // show screen
                _this.showDisplayView("error");
            }
            else if (pResponse.data.responseCode == 50018) {
                // analytics
                _this.analyticsService.dtmProductViewDetails('loans', 'insurance', 'student loans', 0, 0, 0, 'offerpending');
                // show screen
                _this.showDisplayView("offerpending");
                _this.removeHeader('add');
            }
            else if (pResponse.data.responseCode == 50059) {
                // Fraud Code: {"code":"D,RR17,BT10,"}
                if (_this.paymentDetails === "STUDENT") {
                    // analytics
                    // let monthlyRepayments = 0;
                    // if (pResponse.data[`interestRate`] && pResponse.data[`term`]) {
                    // 	monthlyRepayments = this.doStudentCalc(pResponse.data[`approvedAmount`], pResponse.data[`interestRate`], pResponse.data[`term`]);
                    // }
                    _this.analyticsService.dtmProductViewDetails('loans', 'insurance', 'student loans', 0, 0, 0, 'decline');
                    _this.analyticsService.dtmFormComplete("complete", (pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null), true);
                    _this.analyticsService.rejectedDtmApplication((pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null), "Student Quote Declined");
                    // show screen
                    _this.showDisplayView("studentDeclined");
                }
                else if (_this.paymentDetails === "SURETY") {
                    // analytics
                    // let monthlyRepayments: any;
                    // if (pResponse.data[`interestRate`] && pResponse.data[`term`]) {
                    // 	monthlyRepayments = this.doSuretyCalc(pResponse.data[`approvedAmount`], pResponse.data[`interestRate`]);
                    // }
                    _this.analyticsService.dtmProductViewDetails('loans', 'insurance', 'student loans', 0, 0, 0, 'decline');
                    _this.analyticsService.dtmFormComplete("complete", (pResponse.data["leaLeadUIDdID"] ? pResponse.data["LeadUID"] : null), true);
                    _this.analyticsService.rejectedDtmApplication((pResponse.data["leaLeadUIDdID"] ? pResponse.data["LeadUID"] : null), "Student Quote Declined");
                    // show screen
                    _this.showDisplayView("suretyDecline");
                }
            }
            else {
                if (_this.studentModalElement) {
                    _this.studentModalElement.classList.remove("modal__dialog--small");
                    _this.studentModalElement.classList.add("modal__dialog--x-large");
                }
                if (_this.studentBottomModalElement) {
                    _this.studentBottomModalElement.classList.remove("modal__dialog--small");
                    _this.studentBottomModalElement.classList.add("modal__dialog--x-large");
                }
                // let field = this.form.querySelector("select[name=qualification-type]")['value'];
                var data = tslib_1.__assign({}, pResponse);
                _this.response = data;
                var responseData = pResponse.data.data.data.studentQuoteOrchChannelRes
                    .quoteOrchChannelBusinessRes.affordabilityDetails;
                var prime = parseFloat(responseData.primeRate);
                pResponse["data"] = responseData;
                if (pResponse.data["variableRate"] == "6") {
                    pResponse.data["interestRate"] =
                        prime + parseFloat(pResponse.data["variableRate"]);
                    pResponse.data["interestRatePotential"] = prime + 1;
                }
                else if (pResponse.data["variableRate"] == "5") {
                    pResponse.data["interestRate"] =
                        prime + parseFloat(pResponse.data["variableRate"]);
                    pResponse.data["interestRatePotential"] = prime;
                }
                else if (pResponse.data["variableRate"] == "4") {
                    pResponse.data["interestRate"] =
                        prime + parseFloat(pResponse.data["variableRate"]);
                    pResponse.data["interestRatePotential"] = prime;
                }
                else {
                    pResponse.data["interestRate"] = parseFloat(pResponse.data["interestRate"]);
                    pResponse.data["interestRatePotential"] = parseFloat(pResponse.data["interestRate"]);
                }
                var shadowElements = form.querySelectorAll(".apply-now__boxes--shadowed");
                var callMeBackNonTractionalSurity = form.querySelector(".callmebacknontransactionsurity");
                var callMeBackTractionalSurity = form.querySelector(".callmebacktransactionsurity");
                var callMeBackNonTractional = form.querySelector(".callmebacknontransaction");
                var callMeBackTractional = form.querySelector(".callmebacktransaction");
                var quoteImage = form.querySelector(".quoteimage");
                var studentloanuptotitle = form.querySelector(".studentloanuptotitle");
                var studentloantitle = form.querySelector(".studentloantitle");
                var studentloanuptotitlesurety = form.querySelector(".studentloanuptotitlesurety");
                var studentloantitlesurety = form.querySelector(".studentloantitlesurety");
                var quoteImageSurety = form.querySelector(".quoteimagesurity");
                if (!_this.response.data.data.data.studentQuoteOrchChannelRes
                    .quoteOrchChannelBusinessRes.hasTransactionalAccount) {
                    _this.removeHeader("add");
                    shadowElements.forEach(function (item) {
                        item.classList.remove("form-item-student-loans-quote__shadownone");
                    });
                    callMeBackNonTractionalSurity.classList.remove("hidden");
                    callMeBackNonTractional.classList.remove("hidden");
                    callMeBackTractionalSurity.classList.add("hidden");
                    callMeBackTractional.classList.add("hidden");
                    quoteImage.classList.add("hidden");
                    studentloantitle.classList.remove("hidden");
                    studentloanuptotitle.classList.add("hidden");
                    studentloantitlesurety.classList.remove("hidden");
                    studentloanuptotitlesurety.classList.add("hidden");
                    quoteImageSurety.classList.add("hidden");
                }
                else {
                    _this.removeHeader("remove");
                    shadowElements.forEach(function (item) {
                        item.classList.add("form-item-student-loans-quote__shadownone");
                    });
                    callMeBackNonTractionalSurity.classList.add("hidden");
                    callMeBackNonTractional.classList.add("hidden");
                    callMeBackTractionalSurity.classList.remove("hidden");
                    callMeBackTractional.classList.remove("hidden");
                    quoteImage.classList.remove("hidden");
                    studentloanuptotitle.classList.remove("hidden");
                    studentloantitle.classList.add("hidden");
                    studentloanuptotitlesurety.classList.remove("hidden");
                    studentloantitlesurety.classList.add("hidden");
                    quoteImageSurety.classList.remove("hidden");
                }
                if (_this.paymentDetails === "STUDENT") {
                    _this.showDisplayStudentSuccess(pResponse, form);
                }
                else if (_this.paymentDetails === "SURETY") {
                    _this.showDisplaySuretySuccess(pResponse, form);
                }
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", 0, 0, 0, "error");
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemStudentLoansQuote.prototype.removeHeader = function (key) {
        var element = document.querySelectorAll("#student-loans-quote-page");
        element.forEach(function (item) {
            if (item.getElementsByTagName("h3")) {
                if (key == "add") {
                    item.getElementsByTagName("h3")[0].classList.add("hidden");
                }
                else {
                    item.getElementsByTagName("h3")[0].classList.remove("hidden");
                }
            }
        });
    };
    FormItemStudentLoansQuote.prototype.doStudentCalc = function (loanAmount, totIntRateCharged, loanTerm) {
        var monthlyServiceFee = 69; // Constant
        var totIntRateChargedPercntg = Number(totIntRateCharged) / 100;
        var paymentsPerYear = 12; // Constant
        var initiationFee = 74.75 + 0.115 * Number(loanAmount);
        if (initiationFee > 1207.5) {
            initiationFee = 1207.5;
        }
        var principleDebt = initiationFee + Number(loanAmount);
        var pmt = principleDebt *
            (totIntRateChargedPercntg /
                paymentsPerYear /
                (1 -
                    Math.pow(1 + totIntRateChargedPercntg / paymentsPerYear, -1 * Number(loanTerm))));
        var totalCostOfCredit = pmt * Number(loanTerm) + monthlyServiceFee * Number(loanTerm);
        var monthlyRepaymentAmt = totalCostOfCredit / Number(loanTerm);
        return monthlyRepaymentAmt;
    };
    FormItemStudentLoansQuote.prototype.doSuretyCalc = function (loanAmount, totIntRateCharged) {
        var monthlyServiceFee = 69; // Constant
        var loanTermFTWS = 12; // Constant
        var loanTermFTAS = 60; // Constant
        var totIntRateChargedPercntg = Number(totIntRateCharged) / 100;
        var paymentsPerYear = 12; // Constant
        var initiationFee = 74.75 + 0.115 * Number(loanAmount);
        if (initiationFee > 1207.5) {
            initiationFee = 1207.5;
        }
        // Full Time While Studying
        var principleDebtFTWS = initiationFee + Number(loanAmount);
        var monthlyRepaymentAmtFTWS = (principleDebtFTWS * totIntRateChargedPercntg) / loanTermFTWS +
            monthlyServiceFee +
            50;
        // Full Time After Studying
        var pmt = principleDebtFTWS *
            (totIntRateChargedPercntg /
                paymentsPerYear /
                (1 -
                    Math.pow(1 + totIntRateChargedPercntg / paymentsPerYear, -1 * loanTermFTAS)));
        var totalCostOfCredit = pmt * loanTermFTAS + monthlyServiceFee * loanTermFTAS;
        var monthlyRepaymentAmtFTAS = totalCostOfCredit / loanTermFTAS;
        return {
            monthlyRepaymentAmtFTWS: monthlyRepaymentAmtFTWS,
            monthlyRepaymentAmtFTAS: monthlyRepaymentAmtFTAS,
        };
    };
    FormItemStudentLoansQuote.prototype.showDisplayStudentSuccess = function (pResponse, form) {
        if (this.response.data.responseCode == 50061) {
            this.showDisplayStudentSuccessLimIn(pResponse, form);
        }
        else {
            this.showDisplayStudentSuccessNew(pResponse, form);
        }
    };
    FormItemStudentLoansQuote.prototype.manageModalSize = function () {
        if (this.studentBottomModalElement) {
            this.studentBottomModalElement.classList.add("modal__dialog--small");
            this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
        }
        if (this.studentModalElement) {
            this.studentModalElement.classList.add("modal__dialog--small");
            this.studentModalElement.classList.remove("modal__dialog--x-large");
        }
    };
    FormItemStudentLoansQuote.prototype.showDisplayStudentSuccessNew = function (pResponse, form) {
        // names
        var _studentFirstName = form.querySelector("input[name=student-first-name]");
        var _scStudentFirstName = form.querySelector(".form__success-container__studentFirstName");
        // display fields
        var studentLoanAmount = form.querySelector(".form__success--container-pc__studentLoanAmount");
        var studentLoanAmountPotential = form.querySelector(".form__success--container-pc__studentLoanAmountPotential");
        var studentEstMonthlyRepayment = form.querySelector(".form__success--container-pc__studentEstMonthlyRepayment");
        var studentEstMonthlyRepaymentPotential = form.querySelector(".form__success--container-pc__studentEstMonthlyRepaymentPotential");
        var studentInterestRate = form.querySelector(".form__success--container-pc__studentInterestRate");
        var studentInterestRatePotential = form.querySelector(".form__success--container-pc__studentInterestRatePotential");
        var studentTerm = form.querySelector(".form__success--container-pc__studentTerm");
        var studentTermPotential = form.querySelector(".form__success--container-pc__studentTermPotential");
        // container fields
        var studentEstMonthlyRepaymentBlock = form.querySelector(".form__success--container-pc__studentEstMonthlyRepayment-block");
        var studentEstMonthlyRepaymentPotentialBlock = form.querySelector(".form__success--container-pc__studentEstMonthlyRepaymentPotential-block");
        var studentTermVarTitle = form.querySelector(".student-term-variable-title");
        var studentTitlePotential = form.querySelector(".potential-student-title");
        var studentLoanTitlePotential = form.querySelector(".loantitle_student");
        var studentPotentialBlock = form.querySelector(".potential-student-block");
        // populate data
        studentEstMonthlyRepaymentBlock.classList.remove("hidden");
        // studentEstMonthlyRepaymentPotentialBlock.classList.remove("hidden");
        _scStudentFirstName.innerHTML = _studentFirstName.value;
        studentTermVarTitle.innerHTML = "Term";
        if (this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.hasTransactionalAccount) {
            studentTitlePotential.classList.add("hidden");
            studentLoanTitlePotential.classList.add("hidden");
            if (studentPotentialBlock) {
                studentPotentialBlock.classList.add("hidden");
            }
            this.manageModalSize();
        }
        else {
            studentTitlePotential.classList.remove("hidden");
            studentLoanTitlePotential.classList.remove("hidden");
            // studentPotentialBlock.classList.remove("hidden");
        }
        if (pResponse.data["approvedAmount"]) {
            // analytics// analytics
            studentLoanAmount.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                style: "currency",
                currency: "ZAR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            if (studentLoanAmountPotential) {
                studentLoanAmountPotential.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
            if (pResponse.data["interestRate"] && pResponse.data["term"]) {
                var _monthlyRepaymentAmt = this.doStudentCalc(pResponse.data["approvedAmount"], pResponse.data["interestRate"], pResponse.data["term"]);
                var _monthlyRepaymentAmtPotential_1 = this.doStudentCalc(pResponse.data["approvedAmount"], pResponse.data["interestRatePotential"], pResponse.data["term"]);
                studentInterestRate.innerHTML = pResponse.data["interestRate"];
                if (studentInterestRatePotential) {
                    studentInterestRatePotential.innerHTML =
                        pResponse.data["interestRatePotential"];
                }
                studentTerm.innerHTML =
                    pResponse.data["term"] + "&nbsp&nbspmonths";
                if (studentTermPotential) {
                    studentTermPotential.innerHTML =
                        pResponse.data["term"] + "&nbsp&nbspmonths";
                }
                studentEstMonthlyRepayment.innerHTML =
                    "R &nbsp&nbsp" +
                        _monthlyRepaymentAmt.toLocaleString("en-ZA", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        });
                if (studentEstMonthlyRepaymentPotential) {
                    studentEstMonthlyRepaymentPotential.innerHTML =
                        "R &nbsp&nbsp" +
                            _monthlyRepaymentAmtPotential_1.toLocaleString("en-ZA", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            });
                }
            }
        }
        // Analytics
        var monthlyRepayments = 0;
        var _monthlyRepaymentAmtPotential = 0;
        if (pResponse.data["interestRate"] && pResponse.data["term"]) {
            monthlyRepayments = this.doStudentCalc(pResponse.data["approvedAmount"], pResponse.data["interestRate"], pResponse.data["term"]);
            _monthlyRepaymentAmtPotential = this.doStudentCalc(pResponse.data["approvedAmount"], pResponse.data["interestRatePotential"], pResponse.data["term"]);
        }
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRate"]
            ? Number(pResponse.data["interestRate"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, Number(monthlyRepayments).toLocaleString("en-ZA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }), "approved");
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRatePotential"]
            ? Number(pResponse.data["interestRatePotential"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, Number(_monthlyRepaymentAmtPotential).toLocaleString("en-ZA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }), "approved");
        this.analyticsService.dtmFormComplete("complete", pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null, true);
        this.analyticsService.offerDtmApplication(pResponse.data["approvedAmount"], pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null);
        // show screen
        this.showDisplayView("studentSuccess");
    };
    FormItemStudentLoansQuote.prototype.showDisplayStudentSuccessLimIn = function (pResponse, form) {
        // names
        var _studentFirstName = form.querySelector("input[name=student-first-name]");
        var _scStudentFirstName = form.querySelector(".form__success-container__studentFirstName");
        // display fields
        var studentLoanAmount = form.querySelector(".form__success--container-pc__studentLoanAmount");
        var studentLoanAmountPotential = form.querySelector(".form__success--container-pc__studentLoanAmountPotential");
        var studentInterestRate = form.querySelector(".form__success--container-pc__studentInterestRate");
        var studentInterestRatePotential = form.querySelector(".form__success--container-pc__studentInterestRatePotential");
        var studentTerm = form.querySelector(".form__success--container-pc__studentTerm");
        var studentTermPotential = form.querySelector(".form__success--container-pc__studentTermPotential");
        // container fields
        var studentEstMonthlyRepaymentBlock = form.querySelector(".form__success--container-pc__studentEstMonthlyRepayment-block");
        var studentEstMonthlyRepaymentPotentialBlock = form.querySelector(".form__success--container-pc__studentEstMonthlyRepaymentPotential-block");
        var studentTermVarTitle = form.querySelector(".student-term-variable-title");
        var studentTermVarPotentialTitle = form.querySelector(".student-term-variable-potential-title");
        var studentTitlePotential = form.querySelector(".potential-student-title");
        var studentLoanTitlePotential = form.querySelector(".loantitle_student");
        var studentPotentialBlock = form.querySelector(".potential-student-block");
        // populate data
        studentEstMonthlyRepaymentBlock.classList.add("hidden");
        studentEstMonthlyRepaymentPotentialBlock.classList.add("hidden");
        _scStudentFirstName.innerHTML = _studentFirstName.value;
        studentTermVarTitle.innerHTML = "Term";
        studentTermVarPotentialTitle.innerHTML = "Term";
        if (this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.hasTransactionalAccount) {
            studentTitlePotential.classList.add("hidden");
            studentLoanTitlePotential.classList.add("hidden");
            if (studentPotentialBlock) {
                studentPotentialBlock.classList.add("hidden");
            }
            this.manageModalSize();
        }
        else {
            studentTitlePotential.classList.remove("hidden");
            studentLoanTitlePotential.classList.remove("hidden");
            // studentPotentialBlock.classList.remove("hidden");
        }
        if (pResponse.data["approvedAmount"]) {
            // analytics
            studentLoanAmount.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                style: "currency",
                currency: "ZAR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            if (studentLoanAmountPotential) {
                studentLoanAmountPotential.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
        }
        if (pResponse.data["interestRate"] && pResponse.data["term"]) {
            studentInterestRate.innerHTML = pResponse.data["interestRate"];
            if (studentInterestRatePotential) {
                studentInterestRatePotential.innerHTML =
                    pResponse.data["interestRatePotential"];
            }
            studentTerm.innerHTML = "Variable";
            if (studentTermPotential) {
                studentTermPotential.innerHTML = "Variable";
            }
        }
        // Analytics
        var monthlyRepayments = 0;
        var monthlyRepaymentspotential = 0;
        if (pResponse.data["interestRate"] && pResponse.data["term"]) {
            monthlyRepayments = this.doStudentCalc(pResponse.data["approvedAmount"], pResponse.data["interestRate"], pResponse.data["term"]);
            monthlyRepaymentspotential = this.doStudentCalc(pResponse.data["approvedAmount"], pResponse.data["interestRatePotential"], pResponse.data["term"]);
        }
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRate"]
            ? Number(pResponse.data["interestRate"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, Number(monthlyRepayments).toLocaleString("en-ZA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }), "approved");
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRatePotential"]
            ? Number(pResponse.data["interestRatePotential"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, Number(monthlyRepaymentspotential).toLocaleString("en-ZA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }), "approved");
        this.analyticsService.dtmFormComplete("complete", pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null, true);
        this.analyticsService.offerDtmApplication(pResponse.data["approvedAmount"], pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null);
        // show screen
        this.showDisplayView("studentSuccess");
    };
    FormItemStudentLoansQuote.prototype.showDisplaySuretySuccess = function (pResponse, form) {
        if (this.response.data.responseCode == 50061) {
            this.showDisplaySuretySuccessLimIn(pResponse, form);
        }
        else {
            this.showDisplaySuretySuccessNew(pResponse, form);
        }
    };
    FormItemStudentLoansQuote.prototype.showDisplaySuretySuccessNew = function (pResponse, form) {
        // names
        var _studentFirstName = form.querySelector("input[name=student-first-name]");
        var _scSuretyStudentFirstName = form.querySelector(".form__success-container__suretyStudentFirstName");
        // display fields
        var suretyLoanAmount = form.querySelector(".form__success--container-pc__suretyLoanAmount");
        var suretyLoanAmountPotential = form.querySelector(".form__success--container-pc__suretyLoanAmountPotential");
        var suretyEstMonthlyRepayment = form.querySelector(".form__success--container-pc__suretyEstMonthlyRepayment");
        var suretyEstMonthlyRepaymentPotential = form.querySelector(".form__success--container-pc__suretyEstMonthlyRepaymentPotential");
        var suretyInterestRate = form.querySelector(".form__success--container-pc__suretyInterestRate");
        var suretyInterestRatePotential = form.querySelector(".form__success--container-pc__suretyInterestRatePotential");
        var suretyPostEstMonthlyRepayment = form.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepayment");
        var suretyPostEstMonthlyRepaymentPotential = form.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepaymentPotential");
        // container fields
        var suretyEstMonthlyRepaymentBlock = form.querySelector(".form__success--container-pc__suretyEstMonthlyRepayment-block");
        var suretyPostEstMonthlyRepaymentBlock = form.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepayment-block");
        var suretyEstMonthlyRepaymentPotentialBlock = form.querySelector(".form__success--container-pc__suretyEstMonthlyRepayment-potential-block");
        var suretyPostEstMonthlyRepaymentPotentialBlock = form.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepayment-potential-block");
        var studentSuretyTitlePotential = form.querySelector(".potential-surety-title");
        var studentSuretyLoanTitlePotential = form.querySelector(".loantitle_surety");
        var studentSuretyPotentialBlock = form.querySelector(".potential-surety-block");
        // populate data
        suretyEstMonthlyRepaymentBlock.classList.remove("hidden");
        suretyPostEstMonthlyRepaymentBlock.classList.remove("hidden");
        if (this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.hasTransactionalAccount) {
            studentSuretyTitlePotential.classList.add("hidden");
            studentSuretyLoanTitlePotential.classList.add("hidden");
            studentSuretyPotentialBlock.classList.add("hidden");
            suretyEstMonthlyRepaymentBlock.classList.add("form-item-student-loans-quote__pad0");
            suretyPostEstMonthlyRepaymentBlock.classList.add("form-item-student-loans-quote__pad0");
            this.manageModalSize();
        }
        else {
            suretyEstMonthlyRepaymentBlock.classList.remove("form-item-student-loans-quote__pad0");
            suretyPostEstMonthlyRepaymentBlock.classList.remove("form-item-student-loans-quote__pad0");
            studentSuretyTitlePotential.classList.remove("hidden");
            studentSuretyLoanTitlePotential.classList.remove("hidden");
        }
        // suretyEstMonthlyRepaymentPotentialBlock.classList.remove("hidden");
        suretyPostEstMonthlyRepaymentPotentialBlock.classList.remove("hidden");
        _scSuretyStudentFirstName.innerHTML = _studentFirstName.value;
        if (pResponse.data["approvedAmount"]) {
            suretyLoanAmount.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                style: "currency",
                currency: "ZAR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            if (suretyLoanAmountPotential) {
                suretyLoanAmountPotential.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
            if (pResponse.data["interestRate"]) {
                var _monthlyRepaymentAmts = this.doSuretyCalc(pResponse.data["approvedAmount"], pResponse.data["interestRate"]);
                var _monthlyRepaymentAmtsPotential = this.doSuretyCalc(pResponse.data["approvedAmount"], pResponse.data["interestRatePotential"]);
                suretyInterestRate.innerHTML = pResponse.data["interestRate"];
                if (suretyInterestRatePotential) {
                    suretyInterestRatePotential.innerHTML =
                        pResponse.data["interestRatePotential"];
                }
                suretyEstMonthlyRepayment.innerHTML =
                    "R &nbsp&nbsp" +
                        _monthlyRepaymentAmts.monthlyRepaymentAmtFTWS.toLocaleString("en-ZA", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        });
                if (suretyEstMonthlyRepaymentPotential) {
                    suretyEstMonthlyRepaymentPotential.innerHTML =
                        "R &nbsp&nbsp" +
                            _monthlyRepaymentAmtsPotential.monthlyRepaymentAmtFTWS.toLocaleString("en-ZA", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            });
                }
                suretyPostEstMonthlyRepayment.innerHTML =
                    "R &nbsp&nbsp" +
                        _monthlyRepaymentAmts.monthlyRepaymentAmtFTAS.toLocaleString("en-ZA", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        });
                if (suretyPostEstMonthlyRepaymentPotential) {
                    suretyPostEstMonthlyRepaymentPotential.innerHTML =
                        "R &nbsp&nbsp" +
                            _monthlyRepaymentAmtsPotential.monthlyRepaymentAmtFTAS.toLocaleString("en-ZA", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            });
                }
            }
        }
        var monthlyRepayments;
        var monthlyRepaymentsPotential;
        if (pResponse.data["interestRate"] && pResponse.data["term"]) {
            monthlyRepayments = this.doSuretyCalc(pResponse.data["approvedAmount"], pResponse.data["interestRate"]);
            monthlyRepaymentsPotential = this.doSuretyCalc(pResponse.data["approvedAmount"], pResponse.data["interestRatePotential"]);
        }
        // analytics
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRate"]
            ? Number(pResponse.data["interestRate"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, monthlyRepayments.monthlyRepaymentAmtFTAS
            ? Number(monthlyRepayments.monthlyRepaymentAmtFTAS).toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            : 0, "approved");
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRatePotential"]
            ? Number(pResponse.data["interestRatePotential"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, monthlyRepaymentsPotential.monthlyRepaymentAmtFTAS
            ? Number(monthlyRepayments.monthlyRepaymentAmtFTAS).toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            : 0, "approved");
        this.analyticsService.dtmFormComplete("complete", pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null, true);
        this.analyticsService.offerDtmApplication(pResponse.data["approvedAmount"], pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null);
        // show screen
        this.showDisplayView("suretySuccess");
    };
    FormItemStudentLoansQuote.prototype.showDisplaySuretySuccessLimIn = function (pResponse, form) {
        // names
        var _studentFirstName = form.querySelector("input[name=student-first-name]");
        var _scSuretyStudentFirstName = form.querySelector(".form__success-container__suretyStudentFirstName");
        // display fields
        var suretyLoanAmount = form.querySelector(".form__success--container-pc__suretyLoanAmount");
        var suretyLoanAmountPotential = form.querySelector(".form__success--container-pc__suretyLoanAmountPotential");
        var suretyInterestRate = form.querySelector(".form__success--container-pc__suretyInterestRate");
        var suretyInterestRatePotential = form.querySelector(".form__success--container-pc__suretyInterestRatePotential");
        // container fields
        var suretyEstMonthlyRepaymentBlock = form.querySelector(".form__success--container-pc__suretyEstMonthlyRepayment-block");
        var suretyPostEstMonthlyRepaymentBlock = form.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepayment-block");
        var suretyEstMonthlyRepaymentPotentialBlock = form.querySelector(".form__success--container-pc__suretyEstMonthlyRepayment-potential-block");
        var suretyPostEstMonthlyRepaymentPotentialBlock = form.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepayment-potential-block");
        var studentSuretyTitlePotential = form.querySelector(".potential-surety-title");
        var studentSuretyLoanTitlePotential = form.querySelector(".loantitle_surety");
        var studentSuretyPotentialBlock = form.querySelector(".potential-surety-block");
        // populate data
        suretyEstMonthlyRepaymentBlock.classList.add("hidden");
        suretyPostEstMonthlyRepaymentBlock.classList.add("hidden");
        if (this.response.data.data.data.studentQuoteOrchChannelRes
            .quoteOrchChannelBusinessRes.hasTransactionalAccount) {
            studentSuretyTitlePotential.classList.add("hidden");
            studentSuretyLoanTitlePotential.classList.add("hidden");
            studentSuretyPotentialBlock.classList.add("hidden");
            suretyEstMonthlyRepaymentBlock.classList.add("form-item-student-loans-quote__pad0");
            suretyPostEstMonthlyRepaymentBlock.classList.add("form-item-student-loans-quote__pad0");
            this.manageModalSize();
        }
        else {
            studentSuretyTitlePotential.classList.remove("hidden");
            studentSuretyLoanTitlePotential.classList.remove("hidden");
            // studentSuretyPotentialBlock.classList.remove("hidden");
            suretyEstMonthlyRepaymentBlock.classList.remove("form-item-student-loans-quote__pad0");
            suretyPostEstMonthlyRepaymentBlock.classList.remove("form-item-student-loans-quote__pad0");
        }
        if (suretyEstMonthlyRepaymentPotentialBlock) {
            suretyEstMonthlyRepaymentPotentialBlock.classList.add("hidden");
        }
        suretyPostEstMonthlyRepaymentPotentialBlock.classList.add("hidden");
        _scSuretyStudentFirstName.innerHTML = _studentFirstName.value;
        if (pResponse.data["approvedAmount"]) {
            suretyLoanAmount.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                style: "currency",
                currency: "ZAR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            if (suretyLoanAmountPotential) {
                suretyLoanAmountPotential.innerHTML = Number(pResponse.data["approvedAmount"]).toLocaleString("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
            if (pResponse.data["interestRate"]) {
                suretyInterestRate.innerHTML = pResponse.data["interestRate"];
                if (suretyInterestRatePotential) {
                    suretyInterestRatePotential.innerHTML =
                        pResponse.data["interestRatePotential"];
                }
            }
        }
        var monthlyRepayments;
        var monthlyRepaymentsPotential;
        if (pResponse.data["interestRate"] && pResponse.data["term"]) {
            monthlyRepayments = this.doSuretyCalc(pResponse.data["approvedAmount"], pResponse.data["interestRate"]);
            monthlyRepaymentsPotential = this.doSuretyCalc(pResponse.data["approvedAmount"], pResponse.data["interestRatePotential"]);
        }
        // analytics
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRate"]
            ? Number(pResponse.data["interestRate"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, monthlyRepayments.monthlyRepaymentAmtFTAS
            ? Number(monthlyRepayments.monthlyRepaymentAmtFTAS).toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            : 0, "limitincrease");
        this.analyticsService.dtmProductViewDetails("loans", "insurance", "student loans", pResponse.data["interestRatePotential"]
            ? Number(pResponse.data["interestRatePotential"])
            : 0, pResponse.data["term"] ? Number(pResponse.data["term"]) : 0, monthlyRepaymentsPotential.monthlyRepaymentAmtFTAS
            ? Number(monthlyRepayments.monthlyRepaymentAmtFTAS).toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            : 0, "limitincrease");
        this.analyticsService.dtmFormComplete("complete", pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null, true);
        this.analyticsService.offerDtmApplication(pResponse.data["approvedAmount"], pResponse.data["LeadUID"] ? pResponse.data["LeadUID"] : null);
        // show screen
        this.showDisplayView("suretySuccess");
    };
    FormItemStudentLoansQuote.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayCallMeBack.classList.add("hidden");
        this.displayVisitBranch.classList.add("hidden");
        this.displayVisitBranchSurety.classList.add("hidden");
        this.displayCallMeBackSurety.classList.add("hidden");
        this.displayOfferPending.classList.add("hidden");
        this.displayLoanExists.classList.add("hidden");
        this.displayStudentReferral.classList.add("hidden");
        this.displaySuretyReferral.classList.add("hidden");
        this.displayStudentDeclined.classList.add("hidden");
        this.displaySuretyDeclined.classList.add("hidden");
        this.displayStudentSuccess.classList.add("hidden");
        this.displaySuretySuccess.classList.add("hidden");
        this.displayLoader.classList.remove("active");
        this.displayFields.classList.remove("active");
        this.displaySuccess.classList.remove("active");
        this.displayError.classList.remove("active");
        this.displayCallMeBack.classList.remove("active");
        this.displayVisitBranch.classList.remove("active");
        this.displayVisitBranchSurety.classList.remove("active");
        this.displayCallMeBackSurety.classList.remove("active");
        this.displayOfferPending.classList.remove("active");
        this.displayLoanExists.classList.remove("active");
        this.displayStudentReferral.classList.remove("active");
        this.displaySuretyReferral.classList.remove("active");
        this.displayStudentDeclined.classList.remove("active");
        this.displaySuretyDeclined.classList.remove("active");
        this.displayStudentSuccess.classList.remove("active");
        this.displaySuretySuccess.classList.remove("active");
        if (pDisplay == "error") {
            if (this.studentModalElement) {
                this.studentModalElement.classList.add("modal__dialog--small");
                this.studentModalElement.classList.remove("modal__dialog--x-large");
            }
            if (this.studentBottomModalElement) {
                this.studentBottomModalElement.classList.add("modal__dialog--small");
                this.studentBottomModalElement.classList.remove("modal__dialog--x-large");
            }
            this.removeHeader("add");
        }
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                this.displaySuccess.classList.add("active");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                this.displayError.classList.add("active");
                break;
            case "callmeback":
                this.displayCallMeBack.classList.remove("hidden");
                this.displayCallMeBack.classList.add("active");
                break;
            case "visitbranch":
                this.displayVisitBranch.classList.remove("hidden");
                this.displayVisitBranch.classList.add("active");
                break;
            case "visitbranchsurety":
                this.displayVisitBranchSurety.classList.remove("hidden");
                this.displayVisitBranchSurety.classList.add("active");
                break;
            case "offerpending":
                this.displayOfferPending.classList.remove("hidden");
                this.displayOfferPending.classList.add("active");
                break;
            case "callmebacksurety":
                this.displayCallMeBackSurety.classList.remove("hidden");
                this.displayCallMeBackSurety.classList.add("active");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                this.displayLoader.classList.add("active");
                break;
            case "loanExists":
                this.displayLoanExists.classList.remove("hidden");
                this.displayLoanExists.classList.add("active");
                break;
            case "studentReferral":
                this.displayStudentReferral.classList.remove("hidden");
                this.displayStudentReferral.classList.add("active");
                break;
            case "suretyReferral":
                this.displaySuretyReferral.classList.remove("hidden");
                this.displaySuretyReferral.classList.add("active");
                break;
            case "studentDeclined":
                this.displayStudentDeclined.classList.remove("hidden");
                this.displayStudentDeclined.classList.add("active");
                break;
            case "suretyDecline":
                this.displaySuretyDeclined.classList.remove("hidden");
                this.displaySuretyDeclined.classList.add("active");
                break;
            case "studentSuccess":
                this.displayStudentSuccess.classList.remove("hidden");
                this.displayStudentSuccess.classList.add("active");
                break;
            case "suretySuccess":
                this.displaySuretySuccess.classList.remove("hidden");
                this.displaySuretySuccess.classList.add("active");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                this.displayFields.classList.add("active");
                break;
        }
    };
    // -- CUSTOM STUDENT LOANS QUOTE VALIDATIONS -- //
    FormItemStudentLoansQuote.prototype.studentLoansQuoteValidations = function (event) {
        var selectionArray = [];
        var paymentDetailsErrorDetails = "This field is required";
        var expensesErrorDetails = "Monthly expenses exceed gross monthly income";
        var validationErrors = false;
        // Payment Details Selection Error
        var paymentDetailsSelectionGroup = this.paymentDetailsSelection[0].closest(".form__group");
        // Expenses Error
        var studentExpensesGroup = this.studentExpenses.closest(".form__group");
        var suretyExpensesGroup = this.suretyExpenses.closest(".form__group");
        // Field array
        selectionArray.push(paymentDetailsSelectionGroup);
        selectionArray.push(studentExpensesGroup);
        selectionArray.push(suretyExpensesGroup);
        var _button = event.target;
        var _form = _button.closest("form");
        var _suretySaId = _form.querySelector("input[name=surety-sa-id]");
        var _studentSaId = _form.querySelector("input[name=student-sa-id]");
        if (_suretySaId.value === _studentSaId.value) {
            this.validationService.addErrorMessage(_suretySaId, [
                "Please note guarantor/surety`s details can`t be the same as the student who`ll be studying",
            ]);
            validationErrors = true;
        }
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Payment Details Selection Error
        if (!paymentDetailsSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.paymentDetails === "") {
                validationErrors = true;
                paymentDetailsSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = paymentDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                paymentDetailsSelectionGroup.appendChild(_errorDiv);
            }
        }
        // Expenses Student Error
        if (!studentExpensesGroup.classList.contains("form__group--hidden") &&
            this.studentGross.value !== "" &&
            this.studentExpenses.value !== "") {
            if (Number(this.studentExpenses.value) >
                Number(this.studentGross.value)) {
                validationErrors = true;
                studentExpensesGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = expensesErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                studentExpensesGroup.appendChild(_errorDiv);
            }
        }
        // Expenses Surer Error
        if (!suretyExpensesGroup.classList.contains("form__group--hidden") &&
            this.suretyGross.value !== "" &&
            this.suretyExpenses.value !== "") {
            if (Number(this.suretyExpenses.value) >
                Number(this.suretyGross.value)) {
                validationErrors = true;
                suretyExpensesGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = expensesErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                suretyExpensesGroup.appendChild(_errorDiv);
            }
        }
        return validationErrors;
    };
    // -- RESET FORM -- //
    FormItemStudentLoansQuote.prototype.resetForm = function () {
        // fields
        this.paymentDetails = "";
        // divs
        this.hideStudentDetails();
        this.hideSuretyDetails();
        if (this.studentSuretyConsentInfoDiv) {
            this.studentSuretyConsentInfoDiv.classList.add("form__group--hidden");
        }
        this.manageModalSize();
        var _cardinalIdInput = this.element.querySelector("input[name=cardinalId]");
        if (_cardinalIdInput) {
            _cardinalIdInput.value = "";
        }
        // names
        var _suretyStudentFirstName = this.element.querySelector(".form__success-container__suretyStudentFirstName");
        if (_suretyStudentFirstName) {
            _suretyStudentFirstName.innerHTML = "";
        }
        var _studentFirstName = this.element.querySelector(".form__success-container__studentFirstName");
        if (_studentFirstName) {
            _studentFirstName.innerHTML = "";
        }
        // display fields
        var suretyLoanAmount = this.element.querySelector(".form__success--container-pc__suretyLoanAmount");
        var suretyLoanAmountPotential = this.element.querySelector(".form__success--container-pc__suretyLoanAmountPotential");
        var suretyEstMonthlyRepayment = this.element.querySelector(".form__success--container-pc__suretyEstMonthlyRepayment");
        var suretyEstMonthlyRepaymentPotential = this.element.querySelector(".form__success--container-pc__suretyEstMonthlyRepaymentPotential");
        var suretyInterestRate = this.element.querySelector(".form__success--container-pc__suretyInterestRate");
        var suretyInterestRatePotential = this.element.querySelector(".form__success--container-pc__suretyInterestRatePotential");
        var suretyPostEstMonthlyRepayment = this.element.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepayment");
        var suretyPostEstMonthlyRepaymentPotential = this.element.querySelector(".form__success--container-pc__suretyPostEstMonthlyRepaymentPotential");
        var studentLoanAmount = this.element.querySelector(".form__success--container-pc__studentLoanAmount");
        var studentLoanAmountPotential = this.element.querySelector(".form__success--container-pc__studentLoanAmountPotential");
        var studentEstMonthlyRepayment = this.element.querySelector(".form__success--container-pc__studentEstMonthlyRepayment");
        var studentEstMonthlyRepaymentPotential = this.element.querySelector(".form__success--container-pc__studentEstMonthlyRepaymentPotential");
        var studentInterestRate = this.element.querySelector(".form__success--container-pc__studentInterestRate");
        var studentInterestRatePotential = this.element.querySelector(".form__success--container-pc__studentInterestRatePotential");
        var studentPostEstMonthlyRepayment = this.element.querySelector(".form__success--container-pc__studentPostEstMonthlyRepayment");
        if (suretyLoanAmount) {
            suretyLoanAmount.innerHTML = "";
        }
        if (suretyLoanAmountPotential) {
            suretyLoanAmountPotential.innerHTML = "";
        }
        if (suretyEstMonthlyRepayment) {
            suretyEstMonthlyRepayment.innerHTML = "";
        }
        if (suretyEstMonthlyRepaymentPotential) {
            suretyEstMonthlyRepaymentPotential.innerHTML = "";
        }
        if (suretyInterestRate) {
            suretyInterestRate.innerHTML = "";
        }
        if (suretyInterestRatePotential) {
            suretyInterestRatePotential.innerHTML = "";
        }
        if (suretyPostEstMonthlyRepayment) {
            suretyPostEstMonthlyRepayment.innerHTML = "";
        }
        if (suretyPostEstMonthlyRepaymentPotential) {
            suretyPostEstMonthlyRepaymentPotential.innerHTML = "";
        }
        if (studentLoanAmount) {
            studentLoanAmount.innerHTML = "";
        }
        if (studentLoanAmountPotential) {
            studentLoanAmountPotential.innerHTML = "";
        }
        if (studentEstMonthlyRepayment) {
            studentEstMonthlyRepayment.innerHTML = "";
        }
        if (studentEstMonthlyRepaymentPotential) {
            studentEstMonthlyRepaymentPotential.innerHTML = "";
        }
        if (studentInterestRate) {
            studentInterestRate.innerHTML = "";
        }
        if (studentInterestRatePotential) {
            studentInterestRatePotential.innerHTML = "";
        }
        if (studentPostEstMonthlyRepayment) {
            studentPostEstMonthlyRepayment.innerHTML = "";
        }
        this.showDisplayView("");
    };
    return FormItemStudentLoansQuote;
}(Base));
export { FormItemStudentLoansQuote };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-student-loans-quote/form-item-student-loans-quote.component.ts
// module id = 983
// module chunks = 0